import { render, staticRenderFns } from "./ProjectStretchGoals.vue?vue&type=template&id=7b6cedc0"
import script from "./ProjectStretchGoals.vue?vue&type=script&lang=js"
export * from "./ProjectStretchGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports